export interface UserSignatureResponse {
  secureId: string;
}

export interface FeatureTogglesModel {
  secureId: string;
}

export interface FeatureTogglesDtoModel {
  secureId: string;
}

export enum FeatureFlag {
  ModuleScimAccountSettings = "enable-scim-account-settings",
  RestConnector = "restconnector",
  RestConnectorOAuth = "restconnectoroauth",
  AzureDevopsCDataConnector = "azure-dev-ops-c-data-connector",
  FeatureWhiteboardBasicShapes = "whiteboard-basic-shapes",
  MarketplaceDirectSubmissionOfInsights = "marketplace_direct_submission_of_insights",
  LockMultiAccount = "lock-multi-account",
  EnableTagManagement = "enable-tag-management",
  EnableInsightRenderingOptimisations = "enable-insight-rendering-optimisations",
  ChartsInLists = "charts-in-lists",
  ClickUpOAuthConnector = "click-up-o-auth-connector",
  ShowTheUserWhoCreated = "show-the-user-who-created",
  OrganizationChartV2 = "organization-chart-v2",
  OrganizationChartV3 = "organization-chart-v3",
  HideExternalTeams = "hide-external-teams",
  FeatureSSOSettings = "sso-settings",
  WhiteboardsSessionManagement = "whiteboards-session-management",
  WorkdayProvisioning = "workday-provisioning",
  FeatureReflections = "reflections",
  ActivityHistory = "audit-trail",
  HideKPIsPermissions = "hide-kpis-permissions",
  AlignmentTreeDragOrPointerNavigation = "alignment-tree-dragging-tool",
  WhiteboardDragOrPointerNavigation = "whiteboard-dragging-tool",
  insightSuggestions = "insight-suggestions",
  DisableDelightedSurveys = "disable-delighted-surveys",
  MandatoryOkrAlignmentFeature = "mandatory-alignment-of-okrs",
  SCIMGroups = "scim-groups",
  DisableTasksFromDesignScore = "disable-tasks-from-design-score",
  NavControlsOnboarding = "nav-controls-onboarding",
  QuantivePlusSuggestions = "kr-tenx-suggestions",
  OkrFiltersImprovement = "okr-filters-improvement",
  SlackChannelDropdownDisabled = "slack-channel-dropdown-disabled",
  QuantivePlusWizard = "quantive-plus-wizard",
  ShareableLinksWithAppliedFilters = "shareable-links-with-applied-filters",
  UploadMediaAvatar = "upload-medi-avatar",
  PiSuggestionDrawerOverviewTab = "pi-suggestion-drawer-overview-tab",
  PiSuggestionDrawerEffectivenessTab = "pi-suggestion-drawer-effectiveness-tab",
  PiSuggestionDrawerAllSuggestionsTab = "pi-suggestion-drawer-all-suggestions-tab",
  PiSuggestionDrawerWhenCreateObjective = "pi-suggestion-drawer-when-create-objective",
  PiSuggestionDrawerWhenCreateKr = "pi-suggestion-drawer-when-create-kr",
  PiSettings = "pi-settings",
  RelatedItems = "related-items",
  A14CreateObjectiveModal = "a14-create-objective-modal",
  PowerBI = "power-bi",
  UiLoadingIndicator = "ui-loading-indicator",
  BypassManageDataPermission = "bypass-manage-data-permission",
  PrivacyNotice = "privacy-notice",
  A14OkrTasks = "a14-okr-tasks",
  A14OkrStatus = "a14-okr-status",
  Arabic = "arabic",
  QuantiveStaticCdn = "quantivestatic-cdn",
  OkrViews = "okr-views",
  AccountMarketingInfo = "account-marketing-info",
  WhiteboardAndReportsNotifications = "reports-whiteboards-notifications",
  PiWhiteboardSuggestions = "pi-whiteboard-suggestions",
  PiContextualSuggestions = "pi-contextual-suggestions",
  AchievedOrNotMetricType = "achieved-or-not-metric-type",
  SessionsInsightboardsKpisNotifications = "sessions-insightboards-kpis-notifications",
  MetricMilestone = "metric-milestone",
  CloneAndMoveOkrModal = "a14-clone-and-move-modals",
  TeamJoinNotification = "team-join-notifications",
  CascadingShouldDecreaseTo = "cascading-should-decrease-to",
  A14EditReviewersModal = "a14-edit-reviewers-modal",
  HomeNext = "home-next",
  A16CascadeModal = "a16-cascade-modal",
  SessionFilterResetToCurrent = "session-filter-reset-to-current",
  MetricTags = "metric-tags",
  NextTopNavBar = "next-top-nav-bar",
  WatchOkrs = "watch-okrs",
  MarketplaceModal = "a16-submit-to-marketplace",
  A14GoalDrawer = "a14-goal-drawer",
  A16NewSlackView = "a16-slack-screen",
  PiInsightsTextToSql = "pi-insights-text-to-sql",
  RelatedItemsAlignmentView = "related-items-alignment-view",
  A14MetricDrawer = "a14-metric-drawer",
  TeamProfileOkrsTab = "team-profile-okrs-tab",
  OkrsPrivateGoals = "okrs.private-goals",
  A14CreateTeamAvatarModal = "a14-create-team-avatar-modal",
  CheckinLinking = "checkin-linking",
  TopNavBarWhiteboard = "top-nav-bar-whiteboard",
  JiraServerblizzard = "jira-server-blizzard",
  EditKrUpdate = "edit-kr-update",
}
